import { getData, deleteData, postDataSerialized } from "../../../infra3d/utils/ajax";
import { Obj } from "../../internal";
/**
 * @class Infra3DGeoserver
 */
export class Infra3DGeoserver extends Obj {
    constructor(baseurl, project, viewer, opt_options) {
        super();
        this.baseurl = baseurl;
        this.project = project;
        this._viewer = viewer;
        //remove last / from baseurl
        if (this.baseurl.slice(-1) == "/")
            this.baseurl = this.baseurl.slice(0, this.baseurl.length - 1);
    }
    readlayerdefinition(onSuccess, onError) {
        const url = this.baseurl + "/" + this.project + "/layerdefinition";
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        getData(url, onSuccess, onError, {}, options);
    }
    readonefeature(featureclass, featureid, onSuccess, onError, variables = {}) {
        const url = this.baseurl + "/" + this.project + "/" + featureclass + "/" + featureid;
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        getData(url, onSuccess, onError, variables, options);
    }
    readfeatures(featureclass, onSuccess, onError, variables = {}) {
        const count = variables.count ? "/count" : "";
        const url = this.baseurl + "/" + this.project + "/" + featureclass + count;
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        getData(url, onSuccess, onError, variables, options);
    }
    addupdatefeatures(featureclass, payload, onSuccess, onError) {
        const url = this.baseurl + "/" + this.project + "/" + featureclass;
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        postDataSerialized(url, payload, onSuccess, onError, options);
    }
    deletefeatures(featureclass, payload, onSuccess, onError) {
        const url = this.baseurl + "/" + this.project + "/" + featureclass + "/delete";
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        postDataSerialized(url, payload, onSuccess, onError, options);
    }
    deleteonefeature(featureclass, featureid, onSuccess, onError) {
        const url = this.baseurl + "/" + this.project + "/" + featureclass + "/" + featureid;
        const options = {
            bearerToken: this._viewer.authObject.accessToken,
            apiKey: this._viewer.authObject.apiKey,
        };
        deleteData(url, onSuccess, onError, options);
    }
}
//# sourceMappingURL=infra3dgeoserver.js.map